import AvailableOrganizations, { loader } from './AvailableOrganizations';

export default AvailableOrganizations;
export { loader as organizationsLoader };
